import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=0e4004b1&"
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports